import { render, staticRenderFns } from "./LicenseSelector.vue?vue&type=template&id=0ca4456a&scoped=true&"
import script from "./LicenseSelector.vue?vue&type=script&lang=js&"
export * from "./LicenseSelector.vue?vue&type=script&lang=js&"
import style0 from "./LicenseSelector.vue?vue&type=style&index=0&id=0ca4456a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca4456a",
  null
  
)

export default component.exports